// extracted by mini-css-extract-plugin
module.exports = {"ownedCollectionDot":"addToPins_ownedCollectionDot__RNkpr","greenDot":"addToPins_greenDot__B8nL6"};